import React, {createContext, useState} from 'react';

export const NavigationFocusContext = createContext();

export const NavigationFocusProvider = ({children}) => {
    const [navigationFocus, setNavigationFocus] = useState({
        firstLevelTriggerElement: null,
        secondLevelTriggerElement: null,
        focusedLevel: null,
        focusFirst: false,
    });

    return (
        <NavigationFocusContext.Provider
            value={{
                navigationFocus,
                setFocusedLevel: (level) => setNavigationFocus((prevState) => ({...prevState, focusedLevel: level})),
                setFocusFirst: (focus) => setNavigationFocus((prevState) => ({...prevState, focusFirst: focus})),

                toSecondLevel: (element) => {
                    setNavigationFocus((prevState) => ({
                        ...prevState,
                        focusFirst: true,
                        firstLevelTriggerElement: element,
                        focusedLevel: 'second',
                    }));
                },
                toThirdLevel: (element) => {
                    setNavigationFocus((prevState) => ({
                        ...prevState,
                        secondLevelTriggerElement: element,
                        focusedLevel: 'third',
                        focusFirst: true,
                    }));
                },
                reset: () => {
                    setNavigationFocus({
                        firstLevelTriggerElement: null,
                        secondLevelTriggerElement: null,
                        focusedLevel: null,
                        focusFirst: false,
                    });
                },
            }}
        >
            {children}
        </NavigationFocusContext.Provider>
    );
};
